import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';
import { SchemaEntityTypeId } from 'services/schemas/types';

// Global Components
import EntityDropdownField from 'components/EntityDropdownField';

// Global Selectors
// @ts-ignore
import { makeSelectWorkTypeValue } from 'services/workTypes/selectors';

interface OwnProps {
    name: string;
    validate?: any;
    workTypeId?: number;
}

interface ConnectedProps {
    workTypeEntityTypeId?: SchemaEntityTypeId;
}

type Props = OwnProps & ConnectedProps;

export class WorkTypeEntityTypeEntityDropdownField extends React.PureComponent<
    Props
> {
    render(): React.ReactElement | null {
        const { name, validate, workTypeId, workTypeEntityTypeId } = this.props;
        if (!workTypeId) {
            return null;
        }
        return (
            <EntityDropdownField
                entityTypeId={workTypeEntityTypeId}
                name={name}
                validate={validate}
            />
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    workTypeEntityTypeId: makeSelectWorkTypeValue('entityTypeId')
});

export default connect(mapStateToProps)(WorkTypeEntityTypeEntityDropdownField);
